import {
  Box,
  Button,
  Checkbox,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  Textarea,
  TextInput,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { useEffect, useState } from "react";
import { repositoryMdm } from "../../../../_base/_const/_constVar";
import { MessageResponse } from "../../../../model/MessageResponse";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";

type InventoryPosition = {
  id: number;
  code: string;
  name: string;
  note: string | null;
  active: boolean;
  codeCommuneWeb: string | null;
  idDistrict: number | null;
  provinceId: number | null;
};

type ProvinceFormProps = {
  id?: string | number;
  onClose: any;
  isEditMode: boolean;
};

const CommuneForm = ({ id, onClose, isEditMode }: ProvinceFormProps) => {
  const entity = {
    id: 0,
    code: "",
    name: "",
    note: "",
    active: false,
    idDistrict: 0,
    provinceId: 0,
    codeCommuneWeb: "",
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [enable, setEnable] = useState(false);
  const [data, setData] = useState<any>([]);
  const [dataDistrict, setDataDistrict] = useState<any>([]);
  const form = useForm<InventoryPosition>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },
    validate: {
      // idDistrict: (value: number | null) => {
      //   if (!value) {
      //     return "Vui lòng nhập mã tỉnh!";
      //   }
      // },
      provinceId: (value: number | null) => {
        if (!value) {
          return "Vui lòng nhập mã tỉnh!";
        }
      },
      // codeCommuneWeb: (value: string | null) => {
      //   if (!value) {
      //     return "Vui lòng nhập mã xã web!";
      //   }
      // },
      name: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập tên xã!";
        }
      },
      code: (value: string | null) => {
        if (!value) {
          return "Vui lòng nhập mã xã!";
        }
      },
    },
  });

  const handleSubmit = async (dataSubmit: InventoryPosition) => {
    open();
    const apiUrl = isEditMode
      ? `/api/v1/TblDmCommuneMoi/update`
      : `/api/v1/TblDmCommuneMoi/create`;
    const dataApi = await repositoryMdm.post<
      MessageResponse<InventoryPosition>
    >(apiUrl, dataSubmit);
    if (dataApi?.success) {
      onClose((prev: any) => !prev);
      modals.closeAll();
    }
    close();
  };
  const callProvince = async () => {
    try {
      const response = await repositoryMdm.get<MessageResponse<[]>>(
        `/api/v1/TblDmProvinceMoi/get-list?Active=true&Take=100`
      );
      if (response && response.success) {
        const result = response.data
          .filter((i: any) => i.id !== null && i.codeprovince !== null)
          .map((item: any) => ({
            value: String(item.id),
            label: `${item.code} - ${item.name}`,
          }));
        setData(result);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  // const callDistrict = async (id: number) => {
  //   try {
  //     const response = await repositoryMdm.get<MessageResponse<[]>>(
  //       `/api/v1/TblDmDistrict/get-select?id=${id}`
  //     );
  //     if (response && response.success) {
  //       const result = response.data
  //         .filter((i: any) => i.value !== null && i.text !== null)
  //         .map((item: any) => ({
  //           value: item.value,
  //           label: item.text,
  //         }));
  //       setDataDistrict(result);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     return;
  //   }
  // };
  const callApiGetData = async () => {
    if (!isEditMode) return;
    const callapi = await repositoryMdm.get<MessageResponse<InventoryPosition>>(
      `/api/v1/TblDmCommuneMoi/update?id=${id}`
    );
    if (!callapi?.success) {
      NotificationExtension.Fails("Bạn không có quyền sửa!!!");
      modals.closeAll();
      return;
    }
    if (callapi) {
      const dataApi = callapi?.data;
      if (dataApi != null) {
        form.setValues(dataApi);
        form.resetDirty(dataApi);
      }
    } else {
      NotificationExtension.Fails("Dữ liệu không tồn tại");
      modals.closeAll();
    }
  };
  useEffect(() => {
    const fetchData = async () => {
      if (id && isEditMode) {
        await callApiGetData();
        // callDistrict(Number(form.getValues().idProvince));
      }
    };

    fetchData();
  }, [id, isEditMode]);

  useEffect(() => {
    if (form.isDirty()) {
      setEnable(true);
    } else {
      setEnable(false);
    }
  }, [form]);
  useEffect(() => {
    callProvince();
  }, []);
  return (
    <Box
      component="form"
      mx="auto"
      onSubmit={form.onSubmit((e: InventoryPosition) => {
        handleSubmit(e);
      })}
      style={{ position: "relative", width: "350px", height: "auto" }}
    >
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />

      <Grid mt={10}>
        <Grid.Col span={12}>
          <Select
            key={form.key("provinceId")}
            label="Tỉnh/thành phố"
            searchable
            placeholder="Tỉnh/thành phố"
            withAsterisk
            data={data}
            value={form.getValues().provinceId?.toString()}
            {...form.getInputProps("provinceId")}
            onChange={(e: any) => {
              form.setFieldValue("provinceId", e ? Number(e) : 0);
              // callDistrict(e ? Number(e) : 0);
            }}
          />
          {/* <Select
            key={form.key("idDistrict")}
            label="Huyện"
            searchable
            placeholder="Huyện"
            withAsterisk
            data={dataDistrict}
            value={form.getValues().idDistrict?.toString()}
            disabled={form.getValues().idProvince === 0}
            {...form.getInputProps("idDistrict")}
            onChange={(e: any) => {
              form.setFieldValue("idDistrict", e);
            }}
          /> */}
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            key={form.key("code")}
            label="Mã xã"
            placeholder="Mã xã"
            withAsterisk
            {...form.getInputProps("code")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <TextInput
            label={"Tên xã"}
            placeholder={"Tên xã"}
            type="text"
            withAsterisk
            key={form.key("name")}
            {...form.getInputProps("name")}
          />
        </Grid.Col>
        {/* <Grid.Col span={12}>
          <TextInput
            label={"Mã web"}
            placeholder={"Mã web"}
            type="text"
            withAsterisk
            key={form.key("codeCommuneWeb")}
            {...form.getInputProps("codeCommuneWeb")}
          />
        </Grid.Col> */}
        <Grid.Col span={12}>
          <Textarea
            label={"Ghi chú"}
            placeholder={"Ghi chú"}
            key={form.key("note")}
            {...form.getInputProps("note")}
          />
        </Grid.Col>
        <Grid.Col span={12}>
          <Checkbox
            key={form.key("active")}
            label="Hoạt động"
            defaultValue={form.getValues().active ?? false}
            defaultChecked={form.getValues().active ?? false}
            {...form.getInputProps("active")}
          />
        </Grid.Col>
      </Grid>

      <Group
        justify="end"
        mt="xs"
        style={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
        }}
      >
        <Button
          type="button"
          color="gray"
          loading={visible}
          onClick={() => {
            modals.closeAll();
          }}
        >
          Đóng
        </Button>
        <Button type="submit" loading={visible}>
          Lưu
        </Button>
      </Group>
    </Box>
  );
};

export default CommuneForm;
